import Lozenge from '@atlaskit/lozenge';
import VisuallyHidden from '@atlaskit/visually-hidden';
import * as React from 'react';
import { SupportAvailability } from '../../types';
import { getPartnerSupportAvailability } from '../../utils';
export const CurrentSupportAvailability = _ref => {
  let {
    availability
  } = _ref;
  if (!availability) {
    return null;
  }
  const availabilityType = getPartnerSupportAvailability({
    availability,
    localTime: Date.now()
  });
  const getLozenge = () => {
    if (availabilityType === SupportAvailability.Open) {
      return /*#__PURE__*/React.createElement(Lozenge, {
        appearance: "success"
      }, "Open now");
    }
    if (availabilityType === SupportAvailability.OnHoliday) {
      return /*#__PURE__*/React.createElement(Lozenge, {
        appearance: "default"
      }, "Closed (Holiday)");
    }
    return /*#__PURE__*/React.createElement(Lozenge, {
      appearance: "default"
    }, "Closed");
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(VisuallyHidden, null, "Support availability:"), getLozenge());
};